"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Summary = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
/**
 * The monthly summary component.
 * @param billing
 * @returns {JSX.Element}
 */
function Summary(_a) {
    var billing = _a.billing;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Billings.TextBlock, null,
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'pt-sm' },
                "Huidige maand \u2022 ",
                billing.description)),
        react_1.default.createElement(storybook_1.Billings.Divider, null),
        react_1.default.createElement(storybook_1.Billings.TextBlock, null,
            react_1.default.createElement("div", { className: 'flex justify-between' },
                react_1.default.createElement("div", { className: 'text-gray-500' },
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'text-gray-500' }, "Inkomsten"),
                    react_1.default.createElement(storybook_1.Texts.Small, null,
                        "Inkomsten uit abonnementen: ",
                        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: billing.prices.subscriptions } })),
                    react_1.default.createElement(storybook_1.Texts.Small, null,
                        "Inkomsten uit Pay-per-view: ",
                        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: billing.prices.payments } }))),
                react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-black', html: true }, billing.prices.income)),
            react_1.default.createElement(storybook_1.Billings.Divider, null)),
        react_1.default.createElement(storybook_1.Billings.TextBlock, null,
            react_1.default.createElement("div", { className: 'flex justify-between' },
                react_1.default.createElement("div", { className: 'text-gray-500' },
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'text-gray-500' }, "Uitgaven"),
                    react_1.default.createElement(storybook_1.Texts.Small, null,
                        "Transactiekosten: ",
                        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: billing.prices.transactions } }),
                        "-"),
                    react_1.default.createElement(storybook_1.Texts.Small, null,
                        "Platformkosten: ",
                        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: billing.prices.platform } }),
                        "-"),
                    react_1.default.createElement(storybook_1.Texts.Small, null,
                        "Transcodingkosten: ",
                        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: billing.prices.transcoding } }),
                        "-")),
                react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-black', html: true },
                    billing.prices.expenses,
                    "-"))));
}
exports.Summary = Summary;
